import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const COLORS = ["#E05236", "#4A5D4E", "#D4A373", "#7D8C96", "#0A0A0A"];

export default function RenameProjectModal({ open, onOpenChange, project, onSave }) {
  const [form, setForm] = useState({ name: "", description: "", color: "#E05236", respect_working_calendar: false });

  useEffect(() => {
    if (project) {
      setForm({
        name: project.name || "",
        description: project.description || "",
        color: project.color || "#E05236",
        respect_working_calendar: !!project.respect_working_calendar,
      });
    }
  }, [project, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black tracking-tight">
            Renommer le projet
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-2">
          <div>
            <Label htmlFor="rn-name" className="text-xs uppercase tracking-[0.15em]">
              Nom du projet
            </Label>
            <Input
              id="rn-name"
              data-testid="rename-name-input"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
              className="mt-2 h-11 rounded-sm"
            />
          </div>
          <div>
            <Label htmlFor="rn-desc" className="text-xs uppercase tracking-[0.15em]">
              Description
            </Label>
            <Textarea
              id="rn-desc"
              data-testid="rename-desc-input"
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              rows={3}
              className="mt-2 rounded-sm"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.15em]">Couleur</Label>
            <div className="flex gap-2 mt-2">
              {COLORS.map((c) => (
                <button
                  key={c}
                  type="button"
                  data-testid={`rename-color-${c}`}
                  onClick={() => setForm({ ...form, color: c })}
                  className={`w-8 h-8 rounded-sm transition-transform ${
                    form.color === c
                      ? "ring-2 ring-offset-2 ring-neutral-950 scale-110"
                      : ""
                  }`}
                  style={{ background: c }}
                />
              ))}
            </div>
          </div>
          <label className="flex items-start gap-3 border border-stone-200 rounded-sm p-3 cursor-pointer hover:border-neutral-950 transition-colors">
            <input
              type="checkbox"
              data-testid="rename-working-calendar-toggle"
              checked={form.respect_working_calendar}
              onChange={(e) => setForm({ ...form, respect_working_calendar: e.target.checked })}
              className="mt-1 w-4 h-4"
            />
            <div className="flex-1">
              <div className="text-sm font-semibold">Calendrier ouvré</div>
              <div className="text-xs text-neutral-500 mt-0.5">
                Les décalages entre dépendances sautent samedis, dimanches et jours fériés du projet.
              </div>
            </div>
          </label>
          <DialogFooter className="pt-2">
            <Button
              type="submit"
              data-testid="rename-submit-btn"
              className="rounded-sm bg-neutral-950 hover:bg-neutral-800 text-white"
            >
              Enregistrer
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
